/** CAREER page */
if ( $('#extended-header').length && $('#job-openings').length ) {
  $(function(){
    $('#tagline .headline .intro').removeClass('h5');
    $('#tagline .headline .wrapper').addClass('large-image');
  });
}
